<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='name'
)
</template>

<script>
import picker from '@/mixins/picker'
import { promoSites } from '@/enums/promo-sites'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Сайты доступа'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    list() {
      return promoSites.toArray()
    }
  }
}
</script>
